import { useEffect, useMemo } from 'react';

import { MenuItemModal } from './MenuItemModal';

import { useMenu } from 'components/MenuContext/MenuContext';
import { OverlaySpinner } from 'components/Spinner';

import { useCart, CartItem } from 'hooks/context/cart';
import { useCloseNavigate } from 'hooks/useCloseNavigate/useCloseNavigate';

import { RouteFC } from 'util/routeTypes';

export const EditMenuItemModal: RouteFC<{ cartId: string }> = ({ path, cartId }) => {
  const { update, find, remove } = useCart();
  const { menu, loading } = useMenu();

  const closeModal = useCloseNavigate('../');

  const cartItem = (cartId && find(cartId)) || undefined;

  const menuItemId = cartItem?.id;

  const menuItem = useMemo(() => menuItemId && menu?.items[menuItemId], [menu, menuItemId]);

  useEffect(() => {
    if (loading || (menu && menuItem)) return;

    if (process.env.NODE_ENV === 'development') {
      console.warn(`Couldn't edit cart item with id '${menuItemId}'`);
    }

    if (cartItem) remove(cartItem);

    closeModal();
  }, [cartItem, closeModal, loading, menu, menuItem, menuItemId, remove]);

  if (!menu || loading) return <OverlaySpinner />;

  if (!menuItem || !cartItem) return null;

  return <MenuItemModal<CartItem> cartItem={cartItem} menuItem={menuItem} onClose={closeModal} onSubmit={update} />;
};

